import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@tark/shared/hooks';

import { apiClient } from '@tark/shared/lib';

import { Link } from 'react-router-dom';

type Counts = { played:number; wins:number; pairs:number };

type Summary = { period:'ALL_TIME'; total:Counts; squads:{squadId:number;squadName:string;counts:Counts}[]; ratingsState:string };

export default function YourGameCard() {

  const { user } = useAuth();

  const query = useQuery({ queryKey:['home-squad-statistics',user?.id], enabled:Boolean(user), staleTime:30000, retry:false,

    queryFn: async ({signal}) => {
      const data=(await apiClient.get<Summary>('/api/v1/web/home/squad-statistics', {signal,headers:{'X-TARK-Expected-User-Id':String(user!.id)}})).data;
      const counts=(value:Counts)=>value&&[value.played,value.wins,value.pairs].every(n=>Number.isSafeInteger(n)&&n>=0);
      if(!data||data.period!=='ALL_TIME'||!counts(data.total)||!Array.isArray(data.squads)||data.squads.some(row=>!row||!Number.isSafeInteger(row.squadId)||row.squadId<=0||typeof row.squadName!=='string'||!counts(row.counts)))throw new Error('Game summary unavailable');
      return data;
    } });

  const denied = [401,403,404,409].includes((query.error as {response?:{status?:number}})?.response?.status ?? 0);

  const data = denied ? undefined : query.data;

  return <section className="tk-game-card" aria-labelledby="your-game-heading">

    <div className="flex items-center justify-between px-4 py-3"><h2 id="your-game-heading">Your game</h2><Link className="text-xs font-semibold text-primary" to="/play">View games</Link></div>

    {query.isLoading ? <p role="status" className="px-4 pb-4 text-sm text-text-muted">Loading your game…</p> : query.isError || !data ? <button className="px-4 pb-4 text-sm text-primary" onClick={() => void query.refetch()}>Retry your game</button> : <>

      <div className="tk-game-row text-text-muted"><span aria-label="Squad"/><span>Played</span><span>Wins</span><span>Pairs</span><span>Rating</span></div>

      <div className="tk-game-row tk-game-total"><strong>All squads</strong><b>{data.total.played}</b><b>{data.total.wins}</b><b>{data.total.pairs}</b><b aria-label="Rating not published">—</b></div>

      <div className="tk-game-squads" data-scroll={data.squads.length > 5} tabIndex={data.squads.length > 5 ? 0 : undefined} aria-label="Your game by squad">

        {data.squads.map(squad => <Link key={squad.squadId} className="tk-game-row" to={`/squads/${squad.squadId}/leaderboard?period=ALL_TIME`} state={{from:'/welcome?mode=community'}}><span className="truncate">{squad.squadName}</span><span>{squad.counts.played}</span><span>{squad.counts.wins}</span><span>{squad.counts.pairs}</span><span aria-label="Rating not published">—</span></Link>)}

      </div>

    </>}

  </section>;

}

